import styled from 'styled-components'

export const Wrapper = styled.section`
  position: relative;
  overflow: hidden;

  .active {
    cursor: initial;
    box-shadow: 0 15px 32px 9px #cfd4dd;
    margin: 0 2rem;

    border-radius: 10px;
    position: relative;
    transition: height 0.6s, width 0.4s;
    width: ${({ activeCardWidth }) =>
      activeCardWidth ? activeCardWidth : 522}px;
    min-width: ${({ activeCardWidth }) =>
      activeCardWidth ? activeCardWidth : 522}px;
    height: ${({ activeCardHeight }) =>
      activeCardHeight ? activeCardHeight : 313}px;
    padding: 2rem;
    z-index: 50;
    @media only screen and (max-width: 665px) {
      min-width: 360px;
      width: 360px;
      height: 360px;
      cursor: grab;
    }
    @media only screen and (max-width: 450px) {
      min-width: 280px;
      width: 280px;
      height: 400px;
    }

    > div {
      padding: 0;
      display: block;
      .head {
        color: ${({ theme }) => theme.colors.buttonDefault};
        margin-bottom: 1.1rem;
        transform: translateY(0%);
        transition: 0.6s ease-in transform, 0.6s ease-in color;
      }
      .sub {
        transform: translateY(0%);
        opacity: 1;
        height: auto;
        transition: 0.6s ease-in transform, 0.6s ease-in opacity 0.1s;
      }
    }
    > svg {
      display: block;
      left: -9px;
      width: 9px;
      opacity: 1;
    }
  }

  background-color: #edf3ff;
  padding-bottom: 11.5rem;
`
export const CardsWrapper = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  position: relative;
  min-height: 379px;
  @media only screen and (max-width: 450px) {
    min-height: 450px;
  }
  > div {
    z-index: 6;
    position: relative;
    ${({ isAnimatingForward }) =>
      isAnimatingForward
        ? `&:first-child {
      z-index: 5;
    }
    &:last-child {
      z-index: 4;
    }
  }`
        : `&:first-child {
    z-index: 4;
  }
  &:last-child {
    z-index: 5;
  }
}`}

`

export const Controller = styled.div`
  width: auto;
  z-index: 50;
  position: absolute;
  right: 47px;
  bottom: 37px;
  display: flex;
  .right > svg {
    z-index: 50;
  }
  @media only screen and (max-width: 665px) {
    right: calc(50%);
    margin-right: -52px;
  }
`

export const ArrowWrapper = styled.div`
  height: 42px;
  width: 42px;
  &:nth-child(2) {
    margin-left: 1rem;
    transform: rotate(180deg);
  }
  cursor: pointer;
  border: 2px solid ${({ theme }) => theme.colors.buttonDefault};
  border-radius: 50%;
  transition: 400ms ease all;
  &:hover {
    filter: brightness(1.2);
  }
`
